import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFontAwesome, faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faLink, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  use() {

    // fas
    library.add(faLink, faPhone, faEnvelope);

    // fab
    library.add(faFontAwesome, faTwitter, faFacebook);
    Vue.component('font-awesome-icon', FontAwesomeIcon);
  }
};
